import React, { useState, useMemo, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useTranslation } from "react-i18next";
import Table from '../../components/Table';
import Select from 'react-select';
import { selectHeaderColumnStyles } from '../../components/shared/styles';

import { showImportAttempt, processImportAttempt } from "../../services/import_attempts";

const ImportAttempts = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const [importAttempt, setImportAttempt] = useState({});
  const [filters, setFilters] = useState({ page: 1, per_page: 10 });
  const { page, per_page } = filters;

  const pagination = useMemo(
    () => ({
      pageIndex: page - 1,
      pageSize: per_page,
    }),
    [page, per_page]
  );

  let { id } = useParams();

  const handlePagination = ({ pageSize, pageIndex }) => {
    setFilters({ ...filters, page: pageIndex + 1, per_page: pageSize });
  };

  useEffect(() => {
    const getData = async () => {
      const { import_attempt } = await showImportAttempt(id);
      setImportAttempt(import_attempt);
    };

    if (id) getData()
  }, [id])

  const columnOptions = [
    { value: '', label: t('importAttempts.mapping.doNotImport') },
    { value: 'team_name', label: t('common.table_team_name') },
    { value: 'team_age', label: t('common.table_team_age') },
    { value: 'email', label: t('common.table_email') },
    { value: 'name', label: t('common.table_name') },
  ];

  const [columnHeaders, setColumnHeaders] = useState(
    columnOptions.reduce((acc, { value, label }) => {
      acc[value] = { value, label };
      return acc;
    }, {})
  );

  const handleHeaderChange = (column, selectedOption) => {
    setColumnHeaders((prev) => ({
      ...prev,
      [column]: selectedOption,
    }));
  };

  const renderColumnHeader = (columnKey) => (
    <Select
      options={columnOptions}
      value={columnHeaders[columnKey]}
      onChange={(selectedOption) => handleHeaderChange(columnKey, selectedOption)}
      styles={selectHeaderColumnStyles}
      closeMenuOnSelect={true}
      isSearchable={false}
    />
  );

  const columns = useMemo(
    () => [
      { header: renderColumnHeader('email'), accessorKey: 'email', cell: (info) => info.getValue() },
      { header: renderColumnHeader('name'), accessorKey: 'name', cell: (info) => info.getValue() },
      { header: renderColumnHeader('team_name'), accessorKey: 'team_name', cell: (info) => info.getValue() },
      { header: renderColumnHeader('team_age'), accessorKey: 'team_age', cell: (info) => info.getValue() },
    ],
    [columnHeaders]
  );

  const navigateBack = () => {
    navigate("/club_admin/users/");
  };

  return (
    <div className="team-details">
      <div className="team-details-header">
        <div className="team-details-header-text">{t('importAttempts.title')}</div>
      </div>
      <div className="alert-info">
              <h4>{t('importAttempts.countLabel', { count: importAttempt?.raw_data?.length })}</h4>
              <div className="alert-text">
                {t('importAttempts.textMuted')}
              </div>
      </div>
      <div className="team-details-list">
        <Table
          {...{
            data: importAttempt?.raw_data || [],
            columns,
            pageCount: Math.ceil(importAttempt?.raw_data?.length / per_page),
            manualPagination: true,
            onPaginationChange: handlePagination,
          }}
        />
      </div>
      <div className="form-container-actions">
        <div className="flex-end">
          <button className="button" onClick={navigateBack}>
            {t('buttons.common.cancel')}
          </button>
          <button className="button button-primary">
            {t('importAttempts.submit')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ImportAttempts;
